import { DOMSerializer } from 'prosemirror-model';

/**
 * A custom DOMSerializer that extends the default DOMSerializer to add
 * HubSpot-specific functionality.
 *
 * @param schema - The schema to use for the DOMSerializer.
 */
export class HubSpotDOMSerializer extends DOMSerializer {
  static fromSchema(schema) {
    const baseNodeSerializers = DOMSerializer.nodesFromSchema(schema);
    const baseMarkSerializers = DOMSerializer.marksFromSchema(schema);
    return new HubSpotDOMSerializer(baseNodeSerializers, baseMarkSerializers);
  }

  /**
   * Add a modifier function for a node. The modifier function will receive
   * the original DOMOutputSpec as an argument and may return a new DOMOutputSpec.
   *
   * @param nodeName - The name of the node to modify.
   * @param modifier - The modifier function.
   */
  addNodeModifier(nodeName, modifier) {
    const originalSerializer = this.nodes[nodeName];
    this.nodes[nodeName] = node => {
      const initialSpec = originalSerializer(node);
      return modifier(node, initialSpec);
    };
    return this;
  }

  /**
   * Add a modifier function for a mark. The modifier function will receive
   * the original DOMOutputSpec as an argument and may return a new DOMOutputSpec.
   *
   * @param markName - The name of the mark to modify.
   * @param modifier - The modifier function.
   */
  addMarkModifier(markName, modifier) {
    const originalSerializer = this.marks[markName];
    this.marks[markName] = (mark, inline) => {
      const initialSpec = originalSerializer(mark, inline);
      return modifier(mark, inline, initialSpec);
    };
    return this;
  }

  /**
   * Replace a serializer function for a node.
   *
   * @param nodeName - The name of the node to replace.
   * @param serializer - The serializer function.
   */
  replaceNodeSerializer(nodeName, serializer) {
    this.nodes[nodeName] = serializer;
    return this;
  }

  /**
   * Replace a serializer function for a mark.
   *
   * @param markName - The name of the mark to replace.
   * @param serializer - The serializer function.
   */
  replaceMarkSerializer(markName, serializer) {
    this.marks[markName] = serializer;
    return this;
  }
}